import styles from './mortgage-calculator-callout.module.scss';

const CALCULATOR_ICON_SRC = '/assets/images/mortgage-calculator-cta.svg';

export interface MortgageCalculatorCalloutProps {
  href: string;
  label: string;
  onClick?: () => void;
}

export function MortgageCalculatorCallout({ href, label, onClick }: MortgageCalculatorCalloutProps) {
  return (
    <div className={styles.callout}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
        onClick={onClick}
      >
        <img
          src={CALCULATOR_ICON_SRC}
          alt=""
          aria-hidden="true"
          className={styles.icon}
          width={28}
          height={28}
        />
        <span className={styles.label}>{label}</span>
        <span className={styles.arrow} aria-hidden="true">→</span>
      </a>
    </div>
  );
}
